// extracted by css-extract-rspack-plugin
export default {"StatusBanner-subtext":"sputnik__StatusBanner-subtext__AKGbh","statusBannerSubtext":"sputnik__StatusBanner-subtext__AKGbh"};